import UserBasicInfo from './UserBasicInfo';

export default UserBasicInfo;
